import {addLocaleData} from "react-intl";
// en is imported as a default / fallback by react-intl
import _de from "react-intl/locale-data/de.js";
import _es from "react-intl/locale-data/es.js";
import _pt from "react-intl/locale-data/pt.js";
import _fr from "react-intl/locale-data/fr.js";
import _it from "react-intl/locale-data/it.js";
import _ru from "react-intl/locale-data/ru.js";
import _ro from "react-intl/locale-data/ro.js";
import _sv from "react-intl/locale-data/sv.js";
import _nl from "react-intl/locale-data/nl.js";
import _ar from "react-intl/locale-data/ar.js";
import _cs from "react-intl/locale-data/cs.js";
import _gu from "react-intl/locale-data/gu.js";
import _hu from "react-intl/locale-data/hu.js";
import _ja from "react-intl/locale-data/ja.js";
import _ta from "react-intl/locale-data/ta.js";
import _th from "react-intl/locale-data/th.js";
import _zh from "react-intl/locale-data/zh.js";
import _pl from "react-intl/locale-data/pl.js";
import _hi from "react-intl/locale-data/hi.js";
import _mr from "react-intl/locale-data/mr.js";
import _sk from "react-intl/locale-data/sk.js";
import _sl from "react-intl/locale-data/sl.js";
import _sr from "react-intl/locale-data/sr.js";
import _tr from "react-intl/locale-data/tr.js";

addLocaleData(_de);
addLocaleData(_es);
addLocaleData(_pt);
addLocaleData(_fr);
addLocaleData(_it);
addLocaleData(_ru);
addLocaleData(_ro);
addLocaleData(_sv);
addLocaleData(_nl);
addLocaleData(_ar);
addLocaleData(_cs);
addLocaleData(_gu);
addLocaleData(_hu);
addLocaleData(_ja);
addLocaleData(_ta);
addLocaleData(_th);
addLocaleData(_zh);
addLocaleData(_pl);
addLocaleData(_hi);
addLocaleData(_mr);
addLocaleData(_sk);
addLocaleData(_sl);
addLocaleData(_sr);
addLocaleData(_tr);


import de from "./de.js";
import en from "./en.js";
import es from "./es.js";
import pt from "./pt.js";
import fr from "./fr.js";
import it from "./it.js";
import ru from "./ru.js";
import ro from "./ro.js";
import sv from "./sv.js";
import nl from "./nl.js";


export default {
	de,
	en,
	es,
	pt,
	fr,
	it,
	ru,
	ro,
	sv,
	nl,
};



// WEBPACK FOOTER //
// ./lib/locales/index.js